import { TreeList } from "@/regira_modules/treelist";
import { isChoiceProductRoot, isRequired } from "../infrastructure/data-functions";

export default {
  namespaced: true,
  state: () => ({
    maintenance: false,
    klassen: [],
    categories: [],
    productTree: new TreeList(),
  }),
  getters: {
    products: (state) => state.productTree.getValues(),
    findKlas: (state) => (klasId) => state.klassen.find((x) => x.id === klasId),
    findCategory: (state) => (categoryId) => state.categories.find((c) => c.id === categoryId),
    findProductNode: (state) => (productId) => state.productTree.find((pn) => pn.value.id === productId),
    findProduct: (state, getters) => (productId) => (getters.findProductNode(productId) || {}).value,
    choiceProductRoots: (state) => state.productTree.roots.filter((pn) => isChoiceProductRoot(pn)),
    simpleProductNodes: (state) => state.productTree.roots.filter((pn) => !isChoiceProductRoot(pn)),
    isRequired(state, getters, rootState) {
      return (product) => isRequired(product, rootState.webshop);
    },
  },
  mutations: {
    setMaintenance: (state, payload) => (state.maintenance = !!payload),
    setKlassen: (state, payload) => (state.klassen = payload || []),
    setCategories: (state, payload) => {
      const { items, isNewCustomer } = payload;
      state.categories = (items || []).filter((x) => !x.newCustomersOnly || isNewCustomer);
    },
    setProductTree: (state, payload) => {
      const { items, isNewCustomer } = payload;
      const tree = new TreeList();
      const addProducts = (products, isNewCustomer, parentNode = null) => {
        const filteredProducts = products.filter(
          (p) => !p.isUnavailable && state.categories.some((c) => c.id == p.categoryId && (!c.newCustomersOnly || isNewCustomer))
        );
        for (const product of filteredProducts) {
          const node = tree.addValue(product, parentNode);
          if (product.children) {
            addProducts(product.children, isNewCustomer, node);
          }
        }
      };
      addProducts(items || [], isNewCustomer);

      state.productTree = tree;
    },
  },
};
